import { defineAsyncComponent } from 'vue';
import { useQueryParam } from '@composables/utils/useQueryParam';
import common from '../../../constants/common';

/**
 *
 * @returns {import('vue').DefineComponent<any, any, any>?}
 */
export default function useDevLinks() {
  if (useQueryParam('xapiurl').value === 'true' || useQueryParam('devlinks').value === 'true' || localStorage.getItem(common.devLinks) === 'true') {
    return {
      vueComponent: defineAsyncComponent(() => import('../components/DevLinks')),
      mockActivated: true,
    };
  }

  return {
    vueComponent: null,
    mockActivated: false,
  };
}
